import { QcBizConversationInfoForQcConversationSchema } from "./QcBizConversationInfoForQcConversation";
import { QcConversationDetailForUserSchema } from "../group/QcConversationDetailForUser";
import { ModelConversationMemberListSchema } from "../group/ModelConversationMemberList";
import { ModelMessageConnectionSchema } from "./ModelMessageConnection";
import { CallCenterStatusSchema } from "./CallCenterStatus";
import { LimitInfoSchema } from "../group/LimitInfo";
import { z } from "zod";

export type QcConversationForList = z.infer<typeof QcConversationForListSchema>;
export const QcConversationForListSchema = z.object({
  biz_conv_info: QcBizConversationInfoForQcConversationSchema,
  cc_status: CallCenterStatusSchema,
  conversation_detail: QcConversationDetailForUserSchema,
  conversation_name: z.string().nullable(),
  conversation_type: z.string(),
  created_at: z.string(),
  description: z.string().nullable(),
  has_guest_unread: z.boolean(),
  has_unread: z.boolean(),
  icon: z.string(),
  id: z.string(),
  id_account: z.number(),
  importance: z.number(),
  invite_approval_type: z.string(),
  is_anonymous_join: z.boolean(),
  last_talk_at: z.string(),
  memberLimit: z.number().nullable(),
  memberLimitInfo: LimitInfoSchema.nullable(),
  members: ModelConversationMemberListSchema.nullable(),
  messages: ModelMessageConnectionSchema,
  name: z.string(),
  notification_range: z.string(),
  updated_at: z.string(),
});
